import React from 'react';
import { Plus, Edit, Trash2, UserPlus } from 'lucide-react';
import { Badge, Th, Td } from '../WMSShared';

export default function UsersTab({ users, setEditItem, setForm, setModal, delUser }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold">User Management <span className="text-gray-400 font-normal text-base">({users.length})</span></h2>
        <button onClick={() => { setEditItem(null); setForm({ role: 'staff', password: 'password123' }); setModal('user'); }}
          className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 shadow-sm">
          <UserPlus className="w-4 h-4" />Add User
        </button>
      </div>
      <div className="bg-white rounded-xl border shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50"><tr><Th>Name</Th><Th>Email</Th><Th>Role</Th><Th>Department</Th><Th>Phone</Th><Th>Status</Th><Th>Actions</Th></tr></thead>
            <tbody className="divide-y">
              {users.map(u => (
                <tr key={u.user_id} className="hover:bg-gray-50">
                  <Td className="font-medium">{u.name}</Td>
                  <Td className="text-gray-500">{u.email}</Td>
                  <Td><Badge status={u.role} /></Td>
                  <Td className="text-gray-500">{u.department || '-'}</Td>
                  <Td className="text-gray-500">{u.phone || '-'}</Td>
                  <Td>{u.is_active !== false ? <span className="text-xs text-emerald-600 font-medium">Active</span> : <span className="text-xs text-red-600 font-medium">Disabled</span>}</Td>
                  <Td>
                    <div className="flex gap-1">
                      <button onClick={() => { setEditItem(u); setForm(u); setModal('user'); }} className="p-1.5 rounded hover:bg-blue-50 text-gray-400 hover:text-blue-500"><Edit className="w-3.5 h-3.5" /></button>
                      <button onClick={() => delUser(u.user_id)} className="p-1.5 rounded hover:bg-red-50 text-gray-400 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
                    </div>
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
